import React, { useEffect, useRef } from 'react';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet-draw';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet/dist/leaflet.css';
import { parseZonePolygon } from '../../../utils/secteursMapUtils';

const DrawController = ({ initialPolygon, color, onPolygonChange }) => {
  const map = useMap();
  const drawnItemsRef = useRef(null);
  const onChangeRef = useRef(onPolygonChange);

  useEffect(() => {
    onChangeRef.current = onPolygonChange;
  }, [onPolygonChange]);

  useEffect(() => {
    const drawnItems = new L.FeatureGroup();
    drawnItemsRef.current = drawnItems;
    map.addLayer(drawnItems);

    const drawControl = new L.Control.Draw({
      edit: { featureGroup: drawnItems, remove: true },
      draw: {
        polygon: {
          allowIntersection: false,
          shapeOptions: { color: color || '#28a745', fillColor: color || '#28a745', fillOpacity: 0.3 },
        },
        polyline: false,
        rectangle: false,
        circle: false,
        marker: false,
        circlemarker: false,
      },
    });
    map.addControl(drawControl);

    const emitChange = () => {
      let layer = null;
      drawnItems.eachLayer((l) => { layer = l; });
      if (!layer) {
        onChangeRef.current(null, null);
        return;
      }
      const latLngs = layer.getLatLngs()[0];
      const coordinates = latLngs.map((ll) => [ll.lng, ll.lat]);
      const bounds = layer.getBounds();
      const centre = [bounds.getCenter().lng, bounds.getCenter().lat];
      onChangeRef.current([coordinates], centre);
    };

    const coords = parseZonePolygon(initialPolygon);
    if (coords) {
      const polygon = L.polygon(coords, {
        color: color || '#007bff',
        fillColor: color || '#007bff',
        fillOpacity: 0.3,
      });
      drawnItems.addLayer(polygon);
      map.fitBounds(polygon.getBounds(), { padding: [24, 24] });
      emitChange();
    }

    map.on(L.Draw.Event.CREATED, (e) => {
      drawnItems.clearLayers();
      drawnItems.addLayer(e.layer);
      emitChange();
    });
    map.on(L.Draw.Event.EDITED, emitChange);
    map.on(L.Draw.Event.DELETED, () => onChangeRef.current(null, null));

    return () => {
      map.removeControl(drawControl);
      map.removeLayer(drawnItems);
    };
  }, [map, initialPolygon, color]);

  return null;
};

const SecteursZonePolygonEditor = ({ polygon, centre, color = '#007bff', height = 480, onChange }) => {
  const defaultCenter = centre && centre.length >= 2
    ? [Number(centre[1]) || 46.8, Number(centre[0]) || 2.5]
    : [46.9852, 3.1598];

  return (
    <div className="rounded overflow-hidden border" style={{ height }}>
      <MapContainer center={defaultCenter} zoom={13} style={{ height: '100%', width: '100%' }} scrollWheelZoom>
        <TileLayer
          attribution='&copy; OpenStreetMap France'
          url="https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png"
        />
        <DrawController initialPolygon={polygon} color={color} onPolygonChange={onChange} />
      </MapContainer>
    </div>
  );
};

export default SecteursZonePolygonEditor;
